import { req } from '../../@api/request';

export default class MainService {
  static main = async () => {
    const result = await req.get('/main');
    return result.data;
  };
}
